import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { STATES } from '../../data/locations';

export default function LocationsIndex() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 lg:pt-44 lg:pb-28">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6">
              <MapPin className="w-4 h-4" />
              Locations We Serve
            </span>
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Hire faster across <span className="gradient-text">the United States</span>
            </h1>
            <p className="text-lg text-gray-600">
              iHireFast helps businesses across Florida, California, Texas, and New York automate
              their hiring process. Select your state to find local hiring solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {STATES.map((st) => (
              <Link
                key={st.slug}
                to={`/locations/${st.slug}`}
                className="card p-8 group hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary-600 transition-colors">
                  <MapPin className="w-6 h-6 text-primary-600 group-hover:text-white transition-colors" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-1">{st.name}</h2>
                <p className="text-sm text-gray-600 mb-5 leading-relaxed">{st.description}</p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all">
                  Browse {st.name} locations <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
